var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4d05829afc43af71b5b64f21c88c24824e843dfa"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kikushiru@inditidual"]={id:"4d05829afc43af71b5b64f21c88c24824e843dfa"};
      